// extracted by css-extract-rspack-plugin
export default {"outer":"LeadingVisual-module__outer__AfDbwD4","inner":"LeadingVisual-module__inner__YWO7VWy"};